import { Controller } from "@hotwired/stimulus"
import { money, read } from "../../lib/format"

// Order value, times orders a year, times years: the revenue one customer brings.
export default class extends Controller {
  static targets = ["value", "frequency", "lifespan", "clv", "annual"]

  connect() { this.compute() }

  compute() {
    const annual = read(this.valueTarget) * read(this.frequencyTarget)
    this.annualTarget.textContent = money(annual)
    this.clvTarget.textContent = money(annual * read(this.lifespanTarget))
  }
}
